module.exports = __webpack_public_path__ + "img/600.e6e3dfd2.png";